import { API_URL, SECONDARY_API_URL } from '@env';
import { ToastrModule } from 'ngx-toastr';

import { HttpClientModule } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { HAMMER_GESTURE_CONFIG, HammerModule, BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { SnApiModule } from '@lib/api';
import { throwIfAlreadyLoaded } from '@lib/common/helpers';

import { SnHammerGestureConfig } from './gestures';

@NgModule({
  imports: [
    // Angular
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HammerModule,
    // Other
    ToastrModule.forRoot(),
    // Libs
    SnApiModule.forRoot(API_URL, SECONDARY_API_URL),
  ],
  providers: [{ provide: HAMMER_GESTURE_CONFIG, useClass: SnHammerGestureConfig }],
})
export class SnCoreModule {
  constructor(@Optional() @SkipSelf() parentModule: SnCoreModule) {
    throwIfAlreadyLoaded(parentModule, 'SnCoreModule');
  }
}
